
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          <div className="md:col-span-2">
            <div className="mb-6">
              <button 
                onClick={() => scrollToSection('hero')}
                className="text-3xl font-bold bg-gradient-to-r from-teal-400 to-blue-400 bg-clip-text text-transparent cursor-pointer"
                style={{ fontFamily: '"Pacifico", serif' }}
              >
                Noah
              </button>
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed max-w-md">
              Creating beautiful digital experiences with passion and precision. Let's bring your ideas to life with innovative design and development solutions.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-gradient-to-r hover:from-teal-500 hover:to-blue-600 rounded-lg transition-all cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-gradient-to-r hover:from-teal-500 hover:to-blue-600 rounded-lg transition-all cursor-pointer">
                <i className="ri-github-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-gradient-to-r hover:from-teal-500 hover:to-blue-600 rounded-lg transition-all cursor-pointer">
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-gradient-to-r hover:from-teal-500 hover:to-blue-600 rounded-lg transition-all cursor-pointer">
                <i className="ri-dribbble-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  About Me
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('skills')} className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Skills
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('projects')} className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Projects
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-6">Services</h3>
            <ul className="space-y-3 text-gray-300">
              <li>Web Design</li>
              <li>Web Development</li>
              <li>Mobile Apps</li>
              <li>Brand Identity</li>
              <li>UI/UX Design</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-center md:text-left">
              © 2024 Noah. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
